/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Connect_Google_DriveInputs */



/**
* | output |
* | --- |
* | "Connect Google Drive" |
*
* @param {Spaces_Connect_Google_DriveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_connect_google_drive = /** @type {((inputs?: Spaces_Connect_Google_DriveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Connect_Google_DriveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit Google Drive verbinden")
	return /** @type {LocalizedString} */ ("Connect Google Drive")
});